const styles = (theme) => ({
  root: {
    width: '100%',
    maxWidth: 600,
    backgroundColor: theme.palette.background.paper,
    padding: 0,
  },
});

export default styles;
